import React from "react";
import searchIcon from "../../../../assets/images/SearchIcon.png";
import {
  InputAdornment,
  TextField,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSessionResources,
  resourcePageChanged,
  resourcePageLimit,
  searchResourceKeyChanged,
  setResourcePaginationModel,
} from "../../../../redux/slices/session-management.slice";
import deleteIcon from "../../../../assets/images/batchPicture/delete.png";
import Switch from "@mui/material/Switch";
import AddResourcePopUp from "./AddResourcePopup";
import { useState } from "react";
import axiosInstance from "../../../../axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { roles } from "../../../sidenav/constant";
import ReusableDeleteDialogue from "../../../reusableDialog/ReusableDeleteDialogue";
import EditResourcePopUp from "./EditResourcePopUp";
import { resourceTypes } from "./utils";
import { ContentCopy } from "@mui/icons-material";
import CloneResources from "./CloneResources";

const ResourceView = ({ sessionId, role, levelPermission, formType }) => {
  const {
    sessionResourcesData,
    sessionResourcesLoading,
    sessionResourcesTotal,
    sessionResourcesPage,
    sessionResourcesLimit,
    searchResourceKey,
  } = useSelector((state) => state.batchSessionManagement.sessionResources);
  const dispatch = useDispatch();

  const [openCopyResources, setOpenCopyResources] = useState(false);
  const [addResourceOpen, setAddResourceOpen] = useState(false);
  const [editResourceOpen, setEditResourceOpen] = useState(false);
  const [editResourceData, setEditResourceData] = useState(null);
  const [resourceFormType, setResourceFormType] = useState("add");
  const [isDeleteActionOpen, setIsDeleteActionOpen] = useState(false);
  const [deleteResourceId, setDeleteResourceId] = useState(null);

  const handleEditResource = (value) => {
    setEditResourceData(value);
    setResourceFormType("edit");
    setEditResourceOpen(!addResourceOpen);
  };

  const handleAddResource = () => {
    setResourceFormType("add");
    setAddResourceOpen(!addResourceOpen);
  };

  const fetchResources = () => {
    dispatch(
      fetchSessionResources({
        sessionId,
        sessionResourcesPage,
        sessionResourcesLimit,
        searchResourceKey,
      })
    );
  };

  useEffect(() => {
    fetchResources();
  }, [
    dispatch,
    sessionResourcesPage,
    sessionResourcesLimit,
    searchResourceKey,
  ]);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const getFormattedDate = (date) => {
    return new Date(date).toLocaleDateString("en-US");
  };

  const deleteResource = async () => {
    const response = await axiosInstance.delete(
      `/resources/${deleteResourceId}`
    );
    console.log(response);
    if (response.data.statusCode === 200) {
      toast.success(response.data.message, { toastId: "1244" });
      setIsDeleteActionOpen(false);
      setDeleteResourceId(null);
      fetchResources();
    }
  };

  const handleDeleteResource = async (id) => {
    setIsDeleteActionOpen(true);
    setDeleteResourceId(id);
  };

  const handleOpenCopyResources = () => {
    setOpenCopyResources(true);
  };

  const handlePublishChange = async (data) => {
    const payload = {
      resourceType: data.resourceType,
      resourceName: data.resourceName,
      resourceFile: data.resourceFile,
      resourceLink: data.resourceLink,
      isPublish: !data.isPublish,
    };
    const response =
      // {message: response.data.message, isSuccess:response.data.statusCode === 2000}
      await axiosInstance.patch(`/resources/${data.id}`, payload);
    if (response.data.statusCode === 200) {
      toast.success(response.data.message);
      fetchResources();
    }
  };

  // const handleAddResourceClose = () => setAddResourceOpen(false);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      sortable: false,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
              onClick={() => handleEditResource(param.row)} // Pass the ID value
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              {param.row.resourceName ? param.row.resourceName : ""}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "sessionRecording",
      headerName: "Resource Type",
      flex: 1,
      sortable: false,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
              // onClick={() => HandleTitleClick(param.row)} // Pass the ID value
              style={{
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              {param.row.resourceType ? param.row.resourceType : ""}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "addedOn",
      headerName: "Added On",
      flex: 1,
      sortable: false,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => {
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: "14px",
              }}
              // onClick={() => HandleTitleClick(param.row)} // Pass the ID value
            >
              {param.row.createdDate
                ? getFormattedDate(param.row.createdDate)
                : ""}
            </span>
          </Typography>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.5,
      sortable: false,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => (
        <>
          {param?.row?.resourceType === resourceTypes.ASSIGNMENT ? (
            <> </>
          ) : (
            <img
              src={deleteIcon}
              onClick={
                role === "Admin" ||
                (role === roles.SUB_ADMIN && levelPermission)
                  ? () => handleDeleteResource(param.row.id)
                  : () => {}
              }
              alt="action"
              style={{ cursor: "pointer" }}
            />
          )}
        </>
      ),
    },
    {
      field: "publish",
      headerName: "Publish",
      flex: 0.5,
      sortable: false,
      headerClassName: "header-style",
      headerStyle: {
        backgroundColor: "#f5f5f5",
        color: "#333",
        fontWeight: "bold",
      },
      renderCell: (param) => (
        <div>
          <Switch
            {...label}
            defaultChecked={param.row.isPublish}
            onChange={() => handlePublishChange(param.row)}
            disabled={role === roles.SUB_ADMIN && !levelPermission}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="FilterBar--SearchContainer">
        <div
          style={{
            marginTop: "0rem",
            padding: "1rem",
            backgroundColor: "white",
            display: "flex",
            borderRadius: "0.5rem",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          <div>
            <TextField
              // value={searchValue}
              onChange={(e) =>
                dispatch(searchResourceKeyChanged(e.target.value))
              }
              sx={{
                backgroundColor: "#F2F2F2",
                width: "56vw",
                height: "2.5rem",
                padding: "0.2rem 2rem 0.5rem 1.5rem",
                border: "none",
                borderRadius: ".5rem",
                paddingBottom: "10px",
              }}
              placeholder="Search Resourses"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img
                      src={searchIcon}
                      style={{ marginRight: ".4rem" }}
                      alt=""
                    />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              variant="standard"
            />

            {/* <Button
                        sx={{
                          height: "2.5rem",
                          width: "6.5625rem",
                          backgroundColor: "#ffffff",
                          color: "#1A5AFA",
                          borderColor: "#e6e6e6",
                          fontWeight: "600",
                          borderRadius: "0 .5rem .5rem 0 ",
                          textTransform: "capitalize",
                        }}
                        variant="outlined"
                      >
                        Search
                      </Button> */}
            {/* <div style={{ marginLeft: "1rem ", cursor: "pointer" }}>
                        <img
                          onClick={handleAdvanceOpen}
                          style={{ cursor: "pointer" }}
                          src={searchIconFilter}
                          alt="Advance Search"
                        />
                      </div> */}
          </div>

          <div>
            {(role === "Admin" ||
              (role === roles.SUB_ADMIN && levelPermission)) && (
              <div
                style={{
                  display: "flex",
                }}
              >
                <Button
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "#1A5AFA",
                    fontWeight: "bolder",
                    border: "1.5px solid #1A5AFA",
                    marginLeft: "1rem",
                    textTransform: "capitalize",
                    display: "flex",
                  }}
                  variant="outlined"
                  onClick={() => handleAddResource()}
                >
                  + Add
                </Button>
                {/* {formType !== "edit-self-batch" && ( */}
                <Button
                  sx={{
                    backgroundColor: "#ffffff",
                    color: "#1A5AFA",
                    fontWeight: "bolder",
                    border: "1.5px solid #1A5AFA",
                    marginLeft: "1rem",
                    textTransform: "capitalize",
                  }}
                  variant="outlined"
                  onClick={() => handleOpenCopyResources()}
                >
                  <ContentCopy
                    style={{
                      fontSize: "1rem",
                      marginRight: "4px",
                    }}
                  />
                  Clone
                </Button>
                {/* )} */}
              </div>
            )}
          </div>
        </div>
        <Grid
          sx={{
            height: "53vh",
            width: "100%",
            paddingTop: "0px",
            background: "#ffffff",
          }}
        >
          <DataGrid
            sx={{ border: "0px" }}
            rows={sessionResourcesData ? sessionResourcesData : []}
            columns={columns}
            disableColumnMenu
            rowCount={sessionResourcesTotal}
            loading={sessionResourcesLoading === "pending"}
            paginationMode="server"
            // pageSize={sessionResourcesLimit}
            // page={sessionResourcesPage}
            rowsPerPageOptions={[25, 50, 100]}
            onPageSizeChange={(newPageSize) =>
              dispatch(resourcePageLimit(newPageSize))
            }
            onPageChange={(newPage) => dispatch(resourcePageChanged(newPage))}
            disableSelectionOnClick
            paginationModel={{
              page: sessionResourcesPage,
              pageSize: sessionResourcesLimit,
            }}
            onPaginationModelChange={(model) =>
              dispatch(setResourcePaginationModel(model))
            }
          />
        </Grid>
        <AddResourcePopUp
          open={addResourceOpen}
          setAddResourceOpen={setAddResourceOpen}
          resourceFormType={resourceFormType}
          setResourceFormType={setResourceFormType}
          // handleClose={handleAddResourceClose}
          sessionId={sessionId}
          sessionResourcesLimit={sessionResourcesLimit}
          sessionResourcesPage={sessionResourcesPage}
        />
        {editResourceOpen && (
          <EditResourcePopUp
            open={editResourceOpen}
            setEditResourceData={setEditResourceData}
            editResourceData={editResourceData}
            setEditResourceOpen={setEditResourceOpen}
            resourceFormType={resourceFormType}
            setResourceFormType={setResourceFormType}
            // handleClose={handleAddResourceClose}
            sessionId={sessionId}
            sessionResourcesLimit={sessionResourcesLimit}
            sessionResourcesPage={sessionResourcesPage}
          />
        )}

        <ReusableDeleteDialogue
          isOpenDelete={isDeleteActionOpen}
          description={"Are you sure you want to delete this resource."}
          heading={"Delete"}
          yesClicked={deleteResource}
          handleClose={() => setIsDeleteActionOpen(false)}
        />

        {openCopyResources && (
          <CloneResources
            openCopyResources={openCopyResources}
            setOpenCopyResources={setOpenCopyResources}
            fetchResources={fetchResources}
          />
        )}
      </div>
    </>
  );
};

export default ResourceView;
